import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import reducers from '.'
import { loadState } from './localStorage'

const persistedState = loadState()

const configureStore = () => {
  const middlewares = [
    thunk,
  ]

  return createStore(
    reducers,
    persistedState,
    composeWithDevTools(applyMiddleware(...middlewares)),
  )
}

export default configureStore



// WEBPACK FOOTER //
// ./src/config/configureStore.js